import React, { createContext, useState, useEffect, useContext } from "react";
import { Navigate } from "react-router-dom";
import { ShowToast, Severty } from "../helper/toast";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [session, setSession] = useState({ token: null });
  const [isAdmin, setIsAdmin] = useState(true);
  const [userProfile, setUserProfile] = useState();

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (!token) {
      setIsLoggedIn(false);
      setSession({ token: null });
      return;
    }
    let user = localStorage.getItem("userProfile")
      ? JSON.parse(localStorage.getItem("userProfile"))
      : null;
    const userType = user?.userType || user?.type;
    if (userType === "user") {
      localStorage.removeItem("token");
      localStorage.removeItem("userProfile");
      setIsLoggedIn(false);
      setSession({ token: null });
      setUserProfile(undefined);
      window.location.assign("/login");
      ShowToast("You are not allowed to access the panel.", Severty.ERROR);
      return;
    }
    if (user) {
      const normalized = { ...user, type: user.type || user.userType };
      setUserProfile(normalized);
    }
    setIsLoggedIn(true);
    setSession({ token: token });
  }, []);

  useEffect(() => {
    if (!userProfile) return;
    const type = userProfile.type || userProfile.userType;
    if (type === "SubAdmin" || type === "Admin") {
      setIsAdmin(false);
    } else {
      setIsAdmin(true);
    }
  }, [userProfile]);

  useEffect(() => {
    if (!isLoggedIn) return;
  }, [isLoggedIn]);

  const login = () => {
    setIsLoggedIn(true);
    return <Navigate to="/dashboard" />;
  };

  const logout = (flag) => {
    console.log("logout here");
    localStorage.removeItem("token");
    localStorage.removeItem("userProfile");
    setIsLoggedIn(false);
    setSession({ token: null });
    setUserProfile();
    window.location.assign("/login");
    if (flag == 1) {
      ShowToast("Session Expired", Severty.ERROR);
    } else {
      ShowToast("Logout Successfully", Severty.SUCCESS);
    }
    return <Navigate to="/login" />;
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserProfile,
        login,
        logout,
        isAdmin,
        setIsAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};
